import React from 'react';
import { Section } from './ui/Section';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'No creía que en 30 días podía cambiar tanto mi diálogo interno. Tu Aura Simple me dio las herramientas que ningún otro libro me había explicado con tanta claridad.',
    author: 'Lucía G.'
  }, {
    text: 'Empecé el ebook sin expectativas y terminé llorando de gratitud en la semana 3. La técnica de revisión cambió mi relación con el pasado.',
    author: 'Martina R.'
  }, {
    text: 'Soy escéptica de todo lo espiritual, pero esto es diferente. Es práctico, claro y funciona.',
    author: 'Valentina S.'
  }, {
    text: 'El capítulo de las relaciones me hizo entender por qué mis vínculos eran tan difíciles. Ahora todo fluye diferente.',
    author: 'Camila T.'
  }, {
    text: 'Llevo años estudiando a Neville Goddard y este ebook sintetiza todo de una manera que nunca había visto.',
    author: 'Diego M.'
  }, {
    text: 'Lo leí en mi celular antes de dormir cada noche. En 30 días, conseguí el trabajo que había estado visualizando.',
    author: 'Sofía L.'
  }, {
    text: 'Simple, profundo y transformador. Exactamente lo que necesitaba para salir del piloto automático.',
    author: 'Ana P.'
  }, {
    text: 'Las técnicas de SATS son increíbles. Nunca pensé que algo tan sencillo pudiera cambiar tanto mi realidad.',
    author: 'Florencia B.'
  }];
  return <div className="bg-beige/50 py-20" data-id="element-120">
      <Section data-id="element-121">
        <div className="text-center mb-16" data-id="element-122">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-123">
            TESTIMONIOS DE NUESTRA COMUNIDAD
          </h2>
          <p className="text-gray-600" data-id="element-124">Historias reales de transformación</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-125">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} whileHover={{
          y: -5,
          boxShadow: '0 10px 30px -10px rgba(0,0,0,0.1)'
        }} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative" data-id="element-126">
              <Quote className="absolute top-6 right-6 text-sage/20 w-8 h-8" data-id="element-127" />
              <div className="flex gap-1 mb-4" data-id="element-128">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-gold text-gold" data-id="element-129" />)}
              </div>
              <p className="text-gray-700 mb-6 italic leading-relaxed" data-id="element-130">
                "{t.text}"
              </p>
              <p className="font-bold text-navy font-heading text-lg" data-id="element-131">
                {t.author}
              </p>
            </motion.div>)}
        </div>
      </Section>
    </div>;
}